import { isAdmin } from '@/authProvider'
import usePhysicalOrders from '../hooks/usePhysicalOrders'
import { TopToolbar, Button, FilterButton } from 'react-admin'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import DownloadIcon from '@mui/icons-material/Download'

const PhysicalOrdersActionButtons = () => {
  const { downloadOpenOrders, updateBatchMetrics } = usePhysicalOrders()

  if (!isAdmin()) return

  return (
    <TopToolbar>
      <Button
        label="Download All Open Orders"
        startIcon={<DownloadIcon />}
        onClick={downloadOpenOrders}
      />
      <Button
        label="Update Batch Metrics"
        startIcon={<CameraAltIcon />}
        onClick={updateBatchMetrics}
      />
      <FilterButton />
    </TopToolbar>
  )
}

export default PhysicalOrdersActionButtons
